import { Injectable } from '@angular/core';

import { BackendApiType } from '@app/shared/types';
import { ENTITY_TYPES } from '@app/shared/types/enums/entityTypes.enum';

import { BaseService, IServiceConfig } from '../base';

@Injectable()
export class RecipeVenueService extends BaseService {
  public static config: IServiceConfig = {
    ENTITY_TYPE: ENTITY_TYPES.RECIPE_VENUE,
    apiEndpoint: 'recipe-venue',
    customEntityRoute: {
      list: 'master',
    },
    backendApiType: BackendApiType.DM,
  };
}
